module.exports = "<div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/shared/leave-block/leave.block.teamplate.html
// module id = 1235
// module chunks = 0